<template>
    <b-badge
        v-b-tooltip="tooltipConfig"
        :variant="badge.variant"
        :tabindex="hasReason ? 0 : null"
        :aria-label="ariaLabel"
    >
        <span v-if="badge.html" v-html="badge.html"></span>
        <template v-else>{{ badge.text }}</template>
        <i
            v-if="hasReason"
            class="fas fa-comment-alt request-badge__reason-icon"
            aria-hidden="true"
        ></i>
    </b-badge>
</template>

<script>
const TOOLTIP_COMMENT_LIMIT = 500;
const FULL_TEXT_HINT = 'Полный текст — в жизненном цикле заявки.';

export default {
    name: 'RequestBadge',
    props: {
        badge: {
            type: Object,
            required: true
        }
    },
    computed: {
        decision() {
            return this.badge && this.badge.decision ? this.badge.decision : null;
        },
        reason() {
            return this.decision && this.decision.comment
                ? String(this.decision.comment).trim()
                : '';
        },
        hasReason() {
            return Boolean(this.reason);
        },
        tooltipReason() {
            if (this.reason.length <= TOOLTIP_COMMENT_LIMIT) return this.reason;
            return `${this.reason.slice(0, TOOLTIP_COMMENT_LIMIT).trimEnd()}…\n${FULL_TEXT_HINT}`;
        },
        tooltipText() {
            if (!this.hasReason) return '';
            const adminNote = this.decision.admin_override
                ? '<div class="request-status-reason-tooltip__admin">Действие выполнил администратор.</div>'
                : '';
            return [
                '<div class="request-status-reason-tooltip__content">',
                `<blockquote>${this.escapeHtml(this.tooltipReason)}</blockquote>`,
                `<div class="request-status-reason-tooltip__footer">— ${this.escapeHtml(this.authorName)}</div>`,
                adminNote,
                '</div>'
            ].join('');
        },
        tooltipConfig() {
            return {
                title: this.tooltipText,
                html: true,
                triggers: 'hover focus click',
                boundary: 'viewport',
                customClass: 'request-status-reason-tooltip'
            };
        },
        ariaLabel() {
            if (!this.hasReason) return null;
            return `${this.badge.text}. ${this.decision.comment_label || 'Причина изменения статуса'}: ${this.tooltipReason}. Автор: ${this.authorName}`;
        },
        authorName() {
            const author = this.decision && this.decision.author ? this.decision.author : null;
            if (!author) return 'Автор не найден';
            return [
                author.last_name || author.lastName || '',
                author.first_name || author.firstName || ''
            ].join(' ').trim() || 'Автор не найден';
        }
    },
    methods: {
        escapeHtml(value) {
            return String(value === undefined || value === null ? '' : value)
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;')
                .replace(/'/g, '&#39;');
        }
    }
};
</script>

<style scoped>
.request-badge__reason-icon {
    margin-left: 0.35rem;
    font-size: 0.72em;
}
</style>

<style>
.request-status-reason-tooltip .tooltip-inner {
    max-width: min(30rem, calc(100vw - 2rem));
    padding: 0.55rem 0.7rem;
    text-align: left;
    overflow-wrap: anywhere;
}

.request-status-reason-tooltip__content blockquote {
    border-left: 3px solid rgba(255, 255, 255, 0.65);
    font-style: italic;
    margin: 0;
    padding: 2px 0 2px 8px;
    white-space: pre-wrap;
}

.request-status-reason-tooltip__footer {
    font-size: 12px;
    font-weight: 700;
    margin-top: 6px;
}

.request-status-reason-tooltip__admin {
    font-size: 11px;
    margin-top: 4px;
    opacity: 0.8;
}
</style>
